import './steps.scss';

export default () => {
	$( '.steps__tabs a' ).on( 'click', function () {
		let target = $( this.hash );

		target = target.length ? target : $( `[name=${this.hash.substr( 1 )}]` );
		if ( target.length ) {
			$( 'html,body' ).animate( {
				scrollTop: target.offset().top,
			}, 1000 );

			return false;
		}
	} );

	$( window ).scroll( function () {
		let windscroll = $( window ).scrollTop();

		$( '.steps__items' ).each( function ( i, el ) {
			if ( $( el ).offset().top - 214 <= windscroll && windscroll <= $( el ).offset().top - 214 + $( el ).height() ) {
				$( '.steps__tabs li.active' ).removeClass( 'active' );
				$( '.steps__tabs li' ).eq( i ).addClass( 'active' );
				$( '.steps__tabs' ).click( function () {
					return !1;
				} );
			}
		} );
	} );

	$( window ).scroll( function ( ) {
		$( '.js-parallax-slide' ).each( function ( i, el ) {
			let img = $( el ).find( 'img' );

			img.css( {
				scale: 1.3,
			} );
			let off = $( window ).height();
			let fromBottom = ( $( el ).offset().top - off ).toFixed();
			let percent = ( window.scrollY - fromBottom ) / off;
			let imgH = img.height() * .3;
			let scrollYimg = ( ( imgH / 2 ) - imgH ) * ( .5 - percent );

			img.css( {
				transform: `translateY(${scrollYimg}px)`,
			} );
		} );
	} );
};
